// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1QMEq","cell":"ColumnAccessor_cell__2anTb","firstCellAccent":"ColumnAccessor_firstCellAccent__3Ndvf"};